"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ShareToSocialMedia(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mg-modal centre " + props.showShareModal
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grade-info",
    style: {
      padding: '0',
      gridRowGap: '10px',
      gridTemplateColumns: 'auto',
      gridAutoRows: 'min-content'
    }
  }, props.isLiveview === true && /*#__PURE__*/_react["default"].createElement("div", {
    className: "shareSkillLevel_heading_wrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "shareSkillLevelTo_heading"
  }, "Share Level"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "shareSkillLevelTo_close_btn cursor-pointer",
    onClick: props.shareModal_close
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: "centre shareSkillLevelTo_close_icon",
    style: {
      fontSize: '25px',
      color: 'black'
    },
    name: "fas fa-times"
  }))), /*#__PURE__*/_react["default"].createElement("img", {
    className: "grade-info_banner-image",
    alt: props.stars,
    src: props.banner_url,
    style: {
      width: "100%"
    }
  }), props.isLiveview !== true && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      padding: '15px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grade-info-social-button-group",
    style: {
      gridTemplateColumns: 'auto auto 1fr 1fr',
      gridColumnGap: 10
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn share-button-box btnHalo",
    onClick: props.shareOnFacebook,
    style: {
      fontFamily: "Roboto",
      color: 'black',
      backgroundColor: "white",
      padding: "8px 12px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    name: "fab fa-facebook-f",
    style: {
      fontSize: '25px'
    }
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn share-button-box btnHalo",
    onClick: props.shareOnTwitter,
    style: {
      fontFamily: "Roboto",
      color: 'black',
      backgroundColor: "white",
      padding: "8px 12px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    name: "fab fa-twitter",
    style: {
      fontSize: '25px'
    }
  })), props.shareLink ? /*#__PURE__*/_react["default"].createElement("button", {
    style: {
      fontFamily: 'unset',
      fontWeight: 'bold',
      fontSize: "12px",
      lineHeight: "14px"
    },
    className: "btnHalo btn share-button-box-copy share_copyButton_fix_width ".concat(props.copiedLink === "" ? "" : "share_copyLink_disable"),
    onClick: function onClick() {
      console.log(props.shareLink);
      props.setCopiedLink(props.shareLink);
      (0, _copyToClipboard["default"])(props.shareLink);
    }
  }, props.copiedLink !== "" ? "LINK COPIED" : "COPY LINK") : null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      direction: "rtl",
      marginTop: "6px"
    },
    onClick: props.shareModal_close
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    "data-e2e": "shareClose",
    className: "centre ptr",
    name: "fas fa-times",
    style: {
      fontSize: '25px',
      color: 'black'
    }
  })))), props.isLiveview === true && /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grade-info-social-button-group",
    style: {
      gridTemplateColumns: 'auto auto 1fr 1fr',
      gridColumnGap: 10,
      margin: "0 15px"
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn share-button-box btnHalo",
    onClick: props.shareOnFacebook,
    style: {
      fontFamily: "Roboto",
      color: 'black',
      backgroundColor: "white",
      padding: "8px 12px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    name: "fab fa-facebook-f",
    style: {
      fontSize: '25px'
    }
  })), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn share-button-box btnHalo",
    onClick: props.shareOnTwitter,
    style: {
      fontFamily: "Roboto",
      color: 'black',
      backgroundColor: "white",
      padding: "8px 12px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    name: "fab fa-twitter",
    style: {
      fontSize: '25px'
    }
  })), props.shareLink ? /*#__PURE__*/_react["default"].createElement("button", {
    style: {
      fontFamily: 'unset',
      fontWeight: 'bold',
      fontSize: "12px",
      lineHeight: "14px"
    },
    className: "btnHalo btn share-button-box-copy share_copyButton_fix_width ".concat(props.copiedLink === "" ? "" : "share_copyLink_disable"),
    onClick: function onClick() {
      console.log(props.shareLink);
      props.setCopiedLink(props.shareLink);
      (0, _copyToClipboard["default"])(props.shareLink);
    }
  }, props.copiedLink !== "" ? "LINK COPIED" : "COPY LINK") : null)
  // <div className="shareSkillLevel_socialButton_wrapper">
  //     <button className='btn social_Btn social_Btn_facebook' onClick={props.shareOnFacebook} >
  //         <span data-e2e="socialShareFacebookRC" className='social_Txt'>Facebook</span>
  //     </button>
  //     <button className='btn social_Btn social_Btn_twitter' onClick={props.shareOnTwitter} >
  //         <span data-e2e="socialShareTwitterRC" className='social_Txt'>Twitter</span>
  //     </button>
  //     {props.shareLink ? <button className={`btnHalo btn share_copyButton ${props.copiedLink === "" ? "" : "share_copyButton_disable"}`} onClick={() => {
  //         console.log(props.shareLink)
  //         props.setCopiedLink(props.shareLink)
  //         copy(props.shareLink);
  //     }}>
  //         {props.copiedLink !== "" ? "LINK COPIED" : "COPY LINK"}
  //     </button> : null}

  // </div>
  ));
}
var _default = ShareToSocialMedia;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/ShareToSocialMedia.js
 ** module id = 2400
 ** module chunks = 0
 **/